import React,{useState} from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from './Components/mshc2025/Header';
import Login from './Components/mshc2025/Login';
import Lobby from './Components/mshc2025/Lobby';
import SpeakerList from './Components/mshc2025/speakers/SpeakerList';
import SpeakerDetails from './Components/mshc2025/speakers/SpeakerDetails';
import SponsorList from './Components/mshc2025/sponsors/Sponsors';
import SponsorDetails from './Components/mshc2025/sponsors/SponsorDetails';
import AttendeesList from './Components/mshc2025/attendee/Attendees';
import AttendeeDetails from './Components/mshc2025/attendee/AttendeeDetails';
import ExhibitHall from './Components/mshc2025/attendee/ExhibitHall';
import ExhibitorDetails from './Components/mshc2025/attendee/ExhibitorDetails';
import ConferenceSchedule from './Components/mshc2025/conference/getSession';
import Maps from './Components/mshc2025/Maps/Maps';
import MapDetail from './Components/mshc2025/Maps/MapDetail';
import UserProfile from './Components/mshc2025/UserProfile';
import LoginSplash from './Components/mshc2025/LoginSplash';
import ExhibitorProfile from './Components/mshc2025/Exhibitor/profile';
import SpeakerProfile from './Components/mshc2025/speakers/SpeakerProfile';
import ChatPage from "./TmChat/mshc2025/chat/ChatPage";
import ChatNotification from "./TmChat/mshc2025/chat/ChatNotification";

import PrivateRoute from './PrivateRoute';


const Mshc2025 = () => {
    const [exhibitorToken,setExhibitorToken] = useState(localStorage.getItem('exhibitorToken') || null);

    return (
        <Router>
            <Header exhibitorToken={exhibitorToken} />
            {exhibitorToken?<ChatNotification />:''}
            <Switch>
                {/* <Route path="/" exact component={Login} /> */}
                <Route path="/mshc2025/login/:id" exact render={(props) => <Login setExhibitorToken={setExhibitorToken} {...props}/>} />
                <PrivateRoute path="/mshc2025/loginSplash" exact component={LoginSplash} />
                <PrivateRoute path="/mshc2025/conference" exact component={ConferenceSchedule} />
                <PrivateRoute path="/mshc2025/lobby" exact component={Lobby} />
                <PrivateRoute path="/mshc2025/speakers" exact component={SpeakerList} />
                <PrivateRoute path="/mshc2025/speakers/:id" exact component={SpeakerDetails} />
                <PrivateRoute path="/mshc2025/sponsors" exact component={SponsorList} />
                <PrivateRoute path="/mshc2025/sponsor/:id" exact component={SponsorDetails} />
                <PrivateRoute path="/mshc2025/attendees" exact component={AttendeesList} />
                <PrivateRoute path="/mshc2025/attendee/exhibitHall" exact component={ExhibitHall} />
                <PrivateRoute path="/mshc2025/attendee/exhibitor/:exhibitorId/:title" exact component={ExhibitorDetails} />
                {/* <PrivateRoute path="/mdapa2024/attendee/:emailId/:userId" exact component={AttendeeDetails} /> */}
                <PrivateRoute path="/mshc2025/attendee/:emailId/" exact component={AttendeeDetails} />
                <PrivateRoute path="/mshc2025/maps" exact component={Maps} />
                <PrivateRoute path="/mshc2025/maps/details" exact component={MapDetail} />
                <PrivateRoute path="/mshc2025/user/profile" exact component={UserProfile} />
                <PrivateRoute path="/mshc2025/exhibitor/profile" exact component={ExhibitorProfile} />
                <PrivateRoute path="/mshc2025/speaker/profile" exact component={SpeakerProfile} />
                <PrivateRoute path="/mshc2025/chat" exact component={ChatPage} />
                

            </Switch>
        </Router>
    )
}
export default Mshc2025;